import {EventEmitter, Injectable} from '@angular/core';
import {UserDetails} from "./auth/user-details.model";

@Injectable()
export class OnBoardLocalStoreService {
  public user_loggedin$: EventEmitter<UserDetails>;

  private static CURRENT_USER : string = 'onBoardcurrentUser';

  constructor() {
    this.user_loggedin$ = new EventEmitter<UserDetails>();
  }

  _setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  _getItem(key: string) {
    return localStorage.getItem(key);
  }

  _saveCurrentUser(user: UserDetails) {
    localStorage.setItem(OnBoardLocalStoreService.CURRENT_USER, JSON.stringify(user));
    this.user_loggedin$.emit(user);
  }

  _getCurrentUser(): UserDetails {
    try {
      return JSON.parse(localStorage.getItem(OnBoardLocalStoreService.CURRENT_USER)) as UserDetails
    } catch(e) {
      console.error("Error retrieving the current user.", e)
      return null;
    }
  }

  _removeCurrentUser() {
    localStorage.removeItem(OnBoardLocalStoreService.CURRENT_USER);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/on-board-local-store.service.ts